import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {AgendaEvent} from '../model/agenda-event';
import {Observable} from 'rxjs';
import {UserContextService} from '../../../application/app-context/user-context/user-context.service';
import {getApplicationTagList} from '../agenda.util';
import {plainToClass} from 'class-transformer';
import {map} from 'rxjs/operators';

@Injectable({
              providedIn: 'root'
            })
export class AgendaEventService {


  readonly agendaUrl = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/dashboard/agenda/events';


  constructor(private http: HttpClient,
              private userContextService: UserContextService,
              private domainUrlService: DomainUrlService) {
  }

  public getAgendaEvents(): Observable<Array<AgendaEvent>> {
    const tagList = getApplicationTagList(this.userContextService.getUserContext());
    const params = new HttpParams().set('solutions', tagList);

    return this.http.get<Array<AgendaEvent>>(`${this.agendaUrl}/next`, {params})
      .pipe(map(v => plainToClass(AgendaEvent, v)));

  }

  public addAgendaEvent(event: AgendaEvent): Observable<AgendaEvent> {
    return this.http.post(this.agendaUrl, event) as Observable<AgendaEvent>;
  }

  public editAgendaEvent(event: AgendaEvent): Observable<AgendaEvent> {
    return this.http.put(this.agendaUrl, event) as Observable<AgendaEvent>;
  }

  public deleteAgendaElement(id: string): Observable<any> {
    return this.http.delete(`${this.agendaUrl}/${id}`);
  }

}
